<template>
    <b-modal id="create_subscriber_modal" @ok="createSubscriber">
        <template slot="modal-title">Create a new subscriber</template>
        <form ref="create_subscriber_form">
            <b-form-group
                    label="Name"
                    label-for="name">
                <b-form-input
                        id="name"
                        v-model="new_subscriber.name"
                        :state="validateName"
                        autofocus
                        required/>
                <b-form-invalid-feedback :state="validateName">
                    Name is invalid, it needs at least {{minNameLength}} characters.
                </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group
                    label="Event"
                    label-for="event">
                <b-form-select
                        id="event"
                        :state="validateEvent"
                        v-model="new_subscriber.event_name"
                        :options="event_options"
                        required/>
                <b-form-invalid-feedback :state="validateEvent">
                    Select an event.
                </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group
                    label="Queue Priority"
                    label-for="priority">
                <b-form-input
                        id="priority"
                        type="range"
                        min="0"
                        max="10"
                        :state="validatePriority"
                        v-model="new_subscriber.priority" required/>
                {{ new_subscriber.priority }}
                <b-form-text id="queueCategory-help">Higher is more important.</b-form-text>
                <b-form-invalid-feedback :state="validatePriority">
                    The priority needs to be a number.
                </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group
                    label="Queue Category"
                    label-for="queueCategory">
                <b-form-input
                        id="queueCategory"
                        placeholder="order_queue"
                        v-model="new_subscriber.queueCategory"/>

                <b-form-text id="queueCategory-help">Optional. Leave empty for the default queue category.</b-form-text>
            </b-form-group>
        </form>
    </b-modal>
</template>

<script>
    import SubscriberRepository from '../../repositories/subscriber.repository';

    export default {
        props: {
            event_options: {
                type: Array,
                default: () => []
            },
            new_subscriber: {
                type: Object,
                default: SubscriberRepository.blankSubscriber
            },
        },
        data() {
            return {
                minNameLength: process.env.VUE_APP_VALIDATION_SUBSCRIBER_MIN_NAME_LENGTH,
                project: null,
                name: '',
                event_id: '',
            }
        },
        methods: {
            checkFields() {
                if (SubscriberRepository.validate.name(this.new_subscriber.name) === false) return false;
                if (SubscriberRepository.validate.event(this.new_subscriber.event_name) === false) return false;
                return true;
            },
            createSubscriber(modal) {
                if (this.$refs.create_subscriber_form.checkValidity() && this.checkFields()) {
                    this.$emit('change-create-loading');
                    SubscriberRepository.post(this.new_subscriber).then(res => {
                        if (res.status === 201) {
                            // Emit the subscriber created event
                            this.$emit('change-create-loading');
                            this.$emit('subscriber-created', res.data);
                            // Notify the user.
                            this.$bvToast.toast(`Subscriber ${res.data.name} successfully created.`, {
                                title: `Subscriber created.`,
                                variant: 'success',
                                solid: true
                            });
                            this.new_subscriber = SubscriberRepository.blankSubscriber();
                        } else {
                            this.$bvToast.toast('Looks like something went wrong while creating a new subscriber.', {
                                title: `Subscriber creation error.`,
                                variant: 'danger',
                                solid: true
                            });
                        }
                    }).catch(error => {
                        this.$emit('change-create-loading');
                        if (error.response.status === 422) {
                            console.error("Errorcode: " + error.response.status + " Type: " + error.response.statusText + " \n details:" + error.response.data['hydra:description']);
                            this.$bvToast.toast('Looks like something went wrong while validating the new subscriber. Check the value\'s of all the fields', {
                                title: `Subscriber validation error.`,
                                variant: 'danger',
                                solid: true
                            });
                        } else {
                            console.error("Errorcode: " + error.response.status + " Type: " + error.response.statusText);
                            this.$bvToast.toast('Looks like something went wrong on the server while creating a new subscriber.', {
                                title: `Subscriber creation error.`,
                                variant: 'danger',
                                solid: true
                            });
                        }
                    });
                } else {
                    modal.preventDefault();
                }
            }
        },
        computed: {
            validateName() {
                return SubscriberRepository.validate.name(this.new_subscriber.name);
            },
            validateEvent() {
                return SubscriberRepository.validate.event(this.new_subscriber.event_name);
            },
            validatePriority() {
                return SubscriberRepository.validate.priority(this.new_subscriber.priority);
            }
        }
    }
</script>
